import React from 'react';
import WarningIcon from '../assets/icons/red_warning.svg';

type QuickBooksErrorModalActionProps = {
  title?: string;
  action?(): void;
  buttonClassName?: string;
};

type QuickBooksErrorModalProps = {
  title?: string;
  children?: React.ReactNode;
  actions?: QuickBooksErrorModalActionProps[];
  active?: boolean;
  onClose?(): void;
};

const QuickBooksErrorModal = (props: QuickBooksErrorModalProps) => {
  const { title = 'Title', children, actions, active, onClose } = props;

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <div className={`quick_books_error_modal ${active ? 'active' : ''}`}>
        <header className="quick_books_error_modal_header">
          <WarningIcon />

          <div className="title">
            <span>{title}</span>
          </div>
        </header>

        <div className="quick_books_error_modal_body">{children}</div>

        <div className="quick_books_error_modal_actions">
          {actions &&
            actions.length > 0 &&
            actions.map((a, idx) => {
              return (
                <div key={idx}>
                  <button
                    className={a.buttonClassName}
                    onClick={() => {
                      if (a.action) a.action();
                    }}
                    type="button"
                  >
                    {a.title || 'Action'}
                  </button>
                </div>
              );
            })}
        </div>
      </div>

      <div
        onClick={() => handleClose()}
        className={`quick_books_error_modal_overlay ${active ? 'active' : ''}`}
      />
    </>
  );
};

export default QuickBooksErrorModal;
